import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { GeneralSuccess } from '@royalaholddelhaize/design-system-pantry-web/assets/illustrations/ah/spots';
import { createTestHook } from '../../utils/create-test-hook';
import css from './success-highlight.module.scss';

interface SuccessHighlightProps {
    children: ReactNode;
    className?: string;
}

export const SuccessHighlight = React.forwardRef<
    HTMLDivElement,
    SuccessHighlightProps & React.ComponentProps<'div'>
>(({ children, className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(css.root, className)}
            {...createTestHook('success-highlight')}
            {...props}
        >
            <GeneralSuccess size={256} />
            {children}
        </div>
    );
});
